import { render, staticRenderFns } from "./FileInput.vue?vue&type=template&id=bed3a81a&scoped=true&"
import script from "./FileInput.vue?vue&type=script&lang=js&"
export * from "./FileInput.vue?vue&type=script&lang=js&"
import style0 from "./FileInput.vue?vue&type=style&index=0&id=bed3a81a&prod&scoped=true&lang=scss&"
import style1 from "./FileInput.vue?vue&type=style&index=1&id=bed3a81a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed3a81a",
  null
  
)

export default component.exports